module.exports = __webpack_public_path__ + "5fa4803a5ebdb280c25df4827b2b1ab3.otf";